import { render, staticRenderFns } from "./AddPersonLocationDialog.vue?vue&type=template&id=648275ae"
import script from "./AddPersonLocationDialog.vue?vue&type=script&lang=js"
export * from "./AddPersonLocationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports